import React, { FC } from 'react';
import returnReason1 from '../../../assets/ReturnReason1.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpBullet, HelpImage, HelpIndent, HelpStep, HelpSubheading, HelpTitle } from './HelpElements';

const ReturnReasonHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('returnReasonHelp');

    return (
        <>
            <HelpTitle>{t('returnReasonHelp_Title')}</HelpTitle>
            <HelpBody>{t('returnReasonHelp_description')}</HelpBody>
            <HelpStep step={1}>{t('returnReasonHelp_step1')}</HelpStep>
            <HelpStep step={2}>{t('returnReasonHelp_step2')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('returnReasonHelp_step2a')}</HelpBullet>
                <HelpBullet>{t('returnReasonHelp_step2b')}</HelpBullet>
            </HelpIndent>
            <HelpImage src={returnReason1} />
            <HelpSubheading>{t('returnReasonHelp_notes')}</HelpSubheading>
            <HelpIndent>
                <HelpBullet>{t('returnReasonHelp_note1')}</HelpBullet>
                <HelpBullet>{t('returnReasonHelp_note2')}</HelpBullet>
            </HelpIndent>
        </>
    );
};

export { ReturnReasonHelp };
